// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"ec9d2261","741":"b442fa94","945":"d5aefa7c"}[chunkId] + ".js";
};